<template>
  <TeaserAccountTile>
    <template v-slot:component>
      <EmailChangeContainer></EmailChangeContainer>
    </template>
    <template v-slot:image>
      <TeaserAenderungen></TeaserAenderungen>
    </template>
  </TeaserAccountTile>
</template>

<script setup lang="ts">
import EmailChangeContainer from '@/components/account-management/emailchange/EmailChangeContainer.vue'
import TeaserAenderungen from '@/componentsTenant/rahmen/images/TeaserAenderungen.vue'
import TeaserAccountTile from '@/components/rahmen/TeaserAccountTile.vue'
</script>

<style lang="scss" scoped>
.box-centered {
  max-width: 619px;
  margin: 0 auto;
}

.img-element {
  padding-bottom: 0;

  &__inner {
    min-height: auto;
  }

  img {
    display: block;
    margin: 0 auto 24px auto;
    min-height: 100px;
    width: auto;
  }
}
</style>
